module.exports = __webpack_public_path__ + "img/home_bg_tab@.ebcf555f.png";